import React, { useState } from "react";
import { Select } from "antd";


import GraphModal from "../GraphModal";
import ExpandIcon from "../../../assets/svg/expandIcon.svg";
import ConstituencyDataTable from "./constituencyDataTable";
// import AgeChart from "./ageChart";
import sampleData from "./sampleData.json";
// import AgeVsCommunityChart from "../utils/Charts/ageVsCommunityChart";
// import AgeChart from "../utils/Charts/ageChart";
// import GenderChart from "../utils/Charts/genderChart";
// import CommunityChart from "../utils/Charts/communityChart";
// import GenderVsCommunityChart from "../utils/Charts/genderVsCommunityChart";
import { getGraphData } from "../utils/getFromattedValue";
// import AgeVsGenderChart from "../utils/Charts/ageVsGenderChart";
import { renderCharts } from "../utils/renderCharts";
import { useTranslation } from "react-i18next";

const ConstituencyInformation = ({
  summaryData,
  constituencyDataList,
  isDataAvailable,
  isLoading,
  constituencyDataType,
  isParliamentary
}) => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState("age");
  const openModal = () => {
    setIsModalVisible(true);
  };
  const closeModal = () => {
    setIsModalVisible(false);
  };
  //graphData for age VS Gender
  const handleSelectChange = (value) => {
    setSelectedOption(value);
  };
  // const graphData = getGraphData(selectedOption, sampleData);
  const graphData = getGraphData(
    selectedOption,
    sampleData,
    constituencyDataList
  );

  return (
    <>
      <div className='constituency-data mt-5 flex flex-col'>
        <h4 className='flex justify-center mb-2 mt-4'>
          {constituencyDataType === 'central' && isParliamentary 
            ? t("Parliamentary Data") 
            : t("Assembly Data")}
        </h4>
        <div className='w-full flex gap-4 cdm-assembly-data-responsive'>
          <div className='w-[50%] cdm-assembly-data-tables-responsive constituenct-data-table'>
            {constituencyDataType === 'central' && isParliamentary 
              ? (<h1>{t("Parliamentary Form 20 Data")}</h1>) 
              : (<h1>{t("Assembly Form 20 Data")}</h1>) 
            }
            {/* {constituencyDataType==='state' && <h1> {t("Assembly")} {t("Form 20 Data")}</h1>}
            {constituencyDataType==='central' && <h1> {t("Parliamentary")} {t("Form 20 Data")}</h1>} */}
             {/* <h1> {t("Constituency")} {t("Form 20 Data")}</h1> */}
            <ConstituencyDataTable
              isDataAvailable={isDataAvailable}
              data={constituencyDataList?.electoralData}
              constituencyLoading={isLoading}
              constituencyDataType={constituencyDataType}
            />
          </div>
          <div className='w-[50%] cdm-assembly-data-tables-responsive constituenct-data-table'>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
             {/* {constituencyDataType==='state' && <h1 className=' ml-6'>{t("Assembly Electoral Data")}</h1>}
             {constituencyDataType==='central' && <h1 className=' ml-6'>{t("Parliamentary Electoral Data")}</h1>} */}
             {constituencyDataType === 'central' && isParliamentary 
              ? (<h1 className="ml-6">{t("Parliamentary Electoral Data")}</h1>) 
              : (<h1 className="ml-6">{t("Assembly Electoral Data")}</h1>) 
            }
              <div className='flex-grow' />
              <div className='ml-auto pr-1'>
                <Select
                  className='mr-2'
                  placeholder='Select'
                  value={selectedOption}
                  onChange={handleSelectChange}
                  disabled={!isDataAvailable}
                >
                  <Select.Option value='age'>{t("age")}</Select.Option>
                  <Select.Option value='gender'>{t("gender")}</Select.Option>
                  {/* <Select.Option value='community'>
                    {t("community")}
                  </Select.Option> */}
                  <Select.Option value='ageGender'>
                    {t("ageVsGender")}
                  </Select.Option>
                  {/* <Select.Option value='ageCommunity'>
                    {t("ageVsCommunity")}
                  </Select.Option>
                  <Select.Option value='ganderCommunity'>
                    {t("genderVsCommunity")}
                  </Select.Option> */}
                </Select>
              </div>
              <img
                className='cursor-pointer'
                src={ExpandIcon}
                alt=''
                onClick={openModal}
              />
            </div>

            {renderCharts(
              selectedOption,
              isDataAvailable,
              graphData,
              isLoading
            )}
          </div>
        </div>
      </div>
      <GraphModal
        isDataAvailable={isDataAvailable}
        isModalVisible={isModalVisible}
        closeModal={closeModal}
        graphData={graphData}
        selectedOption={selectedOption}
      />
    </>
  );
};

export default ConstituencyInformation;
